import { getRefLink } from "../../utils/links";
import logo from "./images/logo_desktop.jpg";
import styles from "./DesktopPage.module.scss";

export const DesktopPage = () => {
    const handler = () => {
        window.location.href = getRefLink(+(process.env.REACT_APP_SITE_REF_ID ?? 0));
    }

    return (
        <div className={styles.container}>
            <div className={styles.centerBlock}>
                <img src={ logo } alt="Бизнесляндия" className={styles.image} />
                
                <p className={styles.text}>
                    Зарабатывайте игровую валюту, участвуйте в увлекательных заданиях и инвестируйте в своё собственное виртуальное предприятие.
                </p>
                <p className={styles.text}>
                    А самое главное, виртуальная валюта — это не просто числа на экране. В «Бизнесляндии» вы можете потратить свои сбережения на участие в розыгрыше и каждый день получать крутые подарки!
                </p>
                <p className={styles.text}>    
                    Нажмите Играть, чтобы присоединится к игре.
                </p>
                
                <button className={styles.button} onClick={ handler }>ИГРАТЬ</button>
            </div>
        </div>
    );
}